
function updateSizeChartUnits(event) {
    const selectedUnit = event.target.value;
    const inputParent = document.querySelector('.size-chart__units-selector-input-inner')

    if (selectedUnit != 'imperial' && selectedUnit != 'metric') {
        return;
    }

    // Get the size chart table
    const sizeChartTableContainer = document.querySelector('.size-chart');

    if (!sizeChartTableContainer || !inputParent) {
        return;
    }

    sizeChartTableContainer.classList.remove('imperial', 'metric');
    sizeChartTableContainer.classList.add(selectedUnit);

    inputParent.classList.remove('imperial', 'metric');
    inputParent.classList.add(selectedUnit);
}

document.addEventListener('DOMContentLoaded', function () {
    // Get unit selector by the name attribute: "size-chart-units"
    const sizeChartUnitsSelector = document.getElementsByName('size-chart-units');

    // Add an event listener to the units selector if it exists
    if (sizeChartUnitsSelector.length > 0) {
        sizeChartUnitsSelector.forEach(function (selector) {
            selector.addEventListener('change', function (event) {
                updateSizeChartUnits(event);
            });
        });
    }

    // Update the size chart units on page load
    updateSizeChartUnits({
        target: {
            value: 'imperial'
        }
    });


    const rowHeads = document.querySelectorAll(".size-chart .row-head")

    for (const el of rowHeads) {
        const observer = new IntersectionObserver(
            ([e]) => {
                e.target.classList.toggle("is-pinned", e.intersectionRatio < 1)
            },
            { threshold: [1] }
        );

        observer.observe(el);
    }
})
